import { ThemeContext } from 'styled-components';
import { colorSet } from '@ccg/core';
import React$1, { useContext } from 'react';
import PropTypes$1 from 'prop-types';
import { useSpring, animated } from 'react-spring';

const RevealTypography = ({
  children,
  isVisible
}) => {
  const theme = useContext(ThemeContext);
  const {
    opacity,
    percent
  } = useSpring({
    from: {
      opacity: 0,
      percent: 0
    },
    percent: isVisible ? 100 : 0,
    opacity: isVisible ? 1 : 0,
    delay: key => key === 'opacity' ? 500 : 400
  });
  return /*#__PURE__*/React$1.createElement(animated.span, {
    key: children,
    style: {
      background: percent.interpolate(o => o < 100 ? `linear-gradient(
                  -90deg,
                  rgba(255, 255, 255, 0) ${o}%,
                  ${colorSet('accent')({
        theme
      })} ${o}%,
                  ${colorSet('accent')({
        theme
      })} 100%
                )` : 'transparent')
    }
  }, /*#__PURE__*/React$1.createElement(animated.span, {
    style: {
      opacity
    }
  }, children));
};

RevealTypography.propTypes = {
  children: PropTypes$1.node,
  isVisible: PropTypes$1.bool
};
RevealTypography.defaultProps = {
  children: null,
  isVisible: false
};

export default RevealTypography;
